import { createContext } from "react";

export type Corner = `${"top" | "bottom"}-${"left" | "right"}`;
export const CornerLayer = createContext<HTMLDivElement | null>(null);
